import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    LinearProgress,
    Box
} from '@mui/material';
import { observer } from 'mobx-react-lite';
import additionalInfo_parallelCreation from '../../../Mobx/AdditionalInfo_parallelCreation';

// A component that displays the status of generating additional information across parallel processes
const AdditionalInfoStatusDialog = observer(({ open, onClose }) => {
    const isCanceled = additionalInfo_parallelCreation.isCanceled;
    const uiStatus = additionalInfo_parallelCreation.uiStatus;

    // Cancel the creation process
    const handleCancel = () => {
        additionalInfo_parallelCreation.cancelCreation();
    };

    // Close the dialog
    const handleClose = () => {
        if (!isCanceled) return; // Prevent closing the dialog by clicking the backdrop
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="xl" fullScreen>
            <DialogTitle>
                <Box display="flex" alignItems="center" flexWrap="wrap" gap={3}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        מצב יצירת דאטה
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        סך כל המילים:{" "}
                        <Box component="span" sx={{ fontSize: '1.2rem', fontWeight: 'bold', color: 'text.primary' }}>
                            {uiStatus.totalWords}
                        </Box>
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        מילים שבוצעו:{" "}
                        <Box component="span" sx={{ fontSize: '1.2rem', fontWeight: 'bold', color: 'text.primary' }}>
                            {uiStatus.completedWords}
                        </Box>
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        מספר תהליכים:{" "}
                        <Box component="span" sx={{ fontSize: '1.2rem', fontWeight: 'bold', color: 'text.primary' }}>
                            {uiStatus.totalProcesses}
                        </Box>
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        אחוזים שבוצעו:{" "}
                        <Box component="span" sx={{ fontSize: '1.2rem', fontWeight: 'bold', color: 'text.primary' }}>
                            {(uiStatus.completedWords / uiStatus.totalWords * 100).toFixed(2)}%
                        </Box>
                    </Typography>
                </Box>
            </DialogTitle>

            <DialogContent dividers>
                <Box display="flex" flexWrap="wrap" gap={2}>
                    {uiStatus.perProcess.map((process, index) => {
                        const progress = Math.round((process.completedCount / process.wordsCount) * 100);
                        return (
                            <Box
                                key={index}
                                width="300px"
                                minHeight={150}
                                p={2}
                                border={1}
                                borderRadius={2}
                                borderColor="grey.300"
                            >
                                <Typography variant="subtitle1">
                                    תהליך {index + 1} - {process.completedCount}/{process.wordsCount} ({progress}%)
                                </Typography>
                                <LinearProgress variant="determinate" value={progress} />
                                <Typography variant="body2" color={process.message.type === 'error' ? 'error' : 'textSecondary'}>
                                    {process.message.text}
                                </Typography>
                            </Box>
                        );
                    })}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel} color="secondary" variant="contained" disabled={isCanceled}>
                    עצור תהליך
                </Button>
                <Button onClick={handleClose} color="primary" variant="outlined" disabled={!isCanceled}>
                    סגור
                </Button>
            </DialogActions>
        </Dialog>
    );
});

export default AdditionalInfoStatusDialog;
